import { render, staticRenderFns } from "./content.vue?vue&type=template&id=5c26c462&scoped=true&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"
import style0 from "./content.vue?vue&type=style&index=0&id=5c26c462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c26c462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c26c462')) {
      api.createRecord('5c26c462', component.options)
    } else {
      api.reload('5c26c462', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=5c26c462&scoped=true&", function () {
      api.rerender('5c26c462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/components/content.vue"
export default component.exports